module.exports = __webpack_public_path__ + "img/ecommerce.8d62a3dc.svg";